import type { PaletteColor } from '@mui/material/styles/createPalette';

import type { ColorPreset } from '.';
import { blue, green, indigo, purple, navy, forest, burgundy, charcoal } from './colors';

export const getPrimary = (preset?: ColorPreset): PaletteColor => {
  switch (preset) {
    case 'blue':
      return blue;
    case 'green':
      return green;
    case 'indigo':
      return indigo;
    case 'purple':
      return purple;
    case 'navy':
      return navy;
    case 'forest':
      return forest;
    case 'burgundy':
      return burgundy;
    case 'charcoal':
      return charcoal;
    default:
      console.error('Invalid color preset, accepted values: "blue", "green", "indigo", "purple", "navy", "forest", "burgundy" or "charcoal".');
      return blue;
  }
};
